import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { reviews, faqs } from "@/mocks/movies";

export default function About() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "光棍影院",
    "url": "https://fjhongjie.cn",
    "description": "光棍影院电影大全收录最新电影免费高清资源，动作片喜剧片等海量免费影视在线观看，经典大片随时畅享。",
    "foundingDate": "2020",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "email": "contact@guanggunyingyuan.com",
      "availableLanguage": ["Chinese"],
    },
  };

  const webPageJsonLd = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "关于光棍影院",
    "description": "了解光棍影院的品牌故事、发展历程和联系方式。光棍影院致力于为用户提供免费高清电影在线观看服务。",
    "url": "https://fjhongjie.cn/about",
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />

      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200">
          <div className="max-w-4xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: "关于我们" },
              ]}
            />
            <div className="px-4 md:px-6 pb-8 text-center">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
                关于光棍影院
              </h1>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                您的免费高清电影在线观看平台
              </p>
            </div>
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h2 className="text-lg md:text-xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
                  <p>
                    光棍影院成立于2020年，是国内领先的免费高清电影在线观看平台。我们致力于为广大影迷提供最新、最全、最优质的影视资源，让每一位用户都能轻松畅享观影乐趣。
                  </p>
                  <p>
                    作为一家专注于电影资源整合与分发的平台，光棍影院收录了海量的动作片、喜剧片、科幻片、爱情片、恐怖片、剧情片、动画片和纪录片等多种类型的电影资源，覆盖国内外热门大片和经典佳作。
                  </p>
                  <p>
                    我们深知用户对于电影画质和更新速度的追求。光棍影院拥有专业的内容运营团队，每日更新最新上映的电影资源，提供高清1080P和超清4K等多种画质选择，确保用户享受到流畅的观影体验。
                  </p>
                  <p>
                    光棍影院的使命是让每一个人都能轻松接触到优质的电影内容。无论您喜欢热血沸腾的动作大片，还是温馨感人的爱情故事，抑或是烧脑悬疑的科幻巨制，在光棍影院都能找到您的心头好。
                  </p>
                </div>
              </div>

              <div>
                <h2 className="text-lg md:text-xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                  我们的优势
                </h2>
                <div className="space-y-3">
                  {[
                    { icon: "ri-movie-2-line", title: "海量片库", desc: "收录数万部国内外电影资源，涵盖各种类型，满足不同观影需求" },
                    { icon: "ri-4k-line", title: "高清画质", desc: "支持1080P至4K超清画质，流畅播放不卡顿，享受影院级观影体验" },
                    { icon: "ri-flashlight-line", title: "更新快速", desc: "专业运营团队每日更新，最新上映大片第一时间上线" },
                    { icon: "ri-user-smile-line", title: "完全免费", desc: "无需注册、无需付费、无需会员，打开网站即可免费观看所有电影" },
                    { icon: "ri-device-line", title: "多端支持", desc: "支持电脑、平板、手机等多种设备，随时随地享受观影乐趣" },
                    { icon: "ri-shield-check-line", title: "安全可靠", desc: "严格的内容审核机制，确保所有资源安全合规，让您放心观看" },
                  ].map((item, index) => (
                    <div key={index} className="flex gap-3 p-4 rounded-lg bg-background-50 border border-background-200/70">
                      <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 rounded-full bg-primary-100 text-primary-600">
                        <i className={`${item.icon} text-lg`}></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                        <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-lg md:text-xl font-bold text-foreground-950 text-center mb-8" style={{ fontFamily: "var(--font-heading)" }}>
              用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {reviews.map((review) => (
                <div
                  key={review.id}
                  className="p-5 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < review.rating ? "ri-star-fill text-yellow-500" : "ri-star-line text-foreground-300"}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    &ldquo;{review.content}&rdquo;
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-medium text-foreground-900">{review.name}</span>
                    <span className="text-xs text-foreground-400">{review.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-lg md:text-xl font-bold text-foreground-950 text-center mb-8" style={{ fontFamily: "var(--font-heading)" }}>
              联系我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
              <div className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-xs text-foreground-500">contact@guanggunyingyuan.com</p>
              </div>
              <div className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-customer-service-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">在线客服</h3>
                <p className="text-xs text-foreground-500">工作日 9:00 - 18:00</p>
              </div>
              <div className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-feedback-line text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">意见反馈</h3>
                <p className="text-xs text-foreground-500">期待您的宝贵意见</p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-lg md:text-xl font-bold text-foreground-950 text-center mb-8" style={{ fontFamily: "var(--font-heading)" }}>
              常见问题
            </h2>
            <div className="space-y-3">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
                >
                  <button
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                    onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  >
                    <h4 className="text-sm font-semibold text-foreground-900 pr-4">
                      <a href="#" onClick={(e) => e.preventDefault()}>{faq.question}</a>
                    </h4>
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i
                        className={`ri-${openFaq === index ? "subtract" : "add"}-line text-foreground-500`}
                      ></i>
                    </div>
                  </button>
                  {openFaq === index && (
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}